"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stylesMap = void 0;
var styles = require("./StepIndicator.css");
exports.stylesMap = new Map([
    ['item2', styles.items2],
    ['item3', styles.items3],
    ['item4', styles.items4],
    ['item5', styles.items5],
    ['item6', styles.items6],
    ['item7', styles.items7],
    ['item8', styles.items8],
]);
//# sourceMappingURL=StepIndicatorProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/StepIndicator/StepIndicatorProps.js
// module id = 1259
// module chunks = 8